import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
    container: {
        backgroundColor: ({ theme }) => theme.palette.bgColor,
        "--Paper-overlay": "transparent !important",
        borderRadius: '8px',
        width: '100%',
    },
    input: {
        display: 'flex',
        justifyContent: 'flex-start',
        height: '100%'
    },
    btn: {
        color: "#FFFFFF",
        backgroundColor: "#B80351",
        "&:hover": {
            backgroundColor: "#B80351",
        },
        fontFamily: 'Rubik',
        marginBottom: '3%',
        width: '25%',
        "&.Mui-disabled": {
            backgroundColor: "#fff"
        }
    },
    inputText: {
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
            { border: ({ theme }) => `1px solid ${theme.palette.text.primary}`, },
    },
    dialogTitle: {
        color: ({ theme }) => theme.palette.text.primary,
        paddingTop: "24px",
        fontSize: "18px"
    },
    helpIcon: {
        fontSize: '15px',
        cursor: 'pointer',
        marginBottom: "-2px"
    },
    refreshIcon: {
        marginLeft: '2%',
        cursor: 'pointer'
    },
    loadingIcon: {
        marginLeft: '15px'
    }
});
